import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

export default function HorizontalCard(props) {
  const card = getImage(props.card);
  const type = props.type;
  const topics = props.topics;
  return (
    <Link to={props.slug} className="bg-white p-3 border border-gray-200 rounded-lg flex flex-col xs:flex-row md:items-center hover:shadow-box"  id={props.id} key={props.id}>
      <div className="xs:w-1/5">
        <GatsbyImage image={card} alt={props.title}/>
      </div>
      <div className="xs:w-4/5 xs:ml-3 text-gray-500">
        <div className={`text-[.5rem] font-bold uppercase rounded ${type === "course" ? 'text-blue-500' : type === "roadmap" ? 'text-indigo-500' : ''}`}>
          {type}
        </div>
        <h3 className="font-medium leading-tight">{props.title}</h3>
        <p className="text-xs mb-0 mt-1">{props.description}</p>
        { topics ? 
          <div className="flex mt-3">
            {topics.map(topic => <div className="bg-ia-indigo-light text-ia-indigo-default py-1 px-2 text-center text-[.5rem] rounded mr-2" key={topic}>{topic}</div>)}
          </div> 
          : 
          <div>
            <hr className="my-3"/>
            <div className="text-xs flex flex-col md:flex-row">
              <h6><b>Instructor:</b> {props.instructor}</h6>
              <h6 className="my-1 md:mx-3 md:my-0"><b>Category:</b> {props.category}</h6>
              { props.duration ? <h6><b>Duration:</b> {props.duration}</h6> : null }
              { props.total ? <h6><b>Total:</b> {props.total} Courses</h6> : null }
            </div> 
          </div>
        }
      </div>
    </Link>
  )
}